import { dayjs } from 'helpers/day';
import { includes, uniq, sort, filter } from 'helpers/ramda';
import { isFutures } from 'helpers/utils';

const analyzeGetDailyTargetTimestamps = ({
  selectedProductIds,
  orders,
  products,
}: {
  selectedProductIds: number[];
  orders: { product_id: number; contract_type?: string }[];
  products: Record<number, { settlement_time?: string | Date | null }>;
}): number[] => {
  const now = dayjs().utc();
  const noonTodayUTC = now.startOf('day').add(12, 'hour');

  const currentTimestamp = now.isAfter(noonTodayUTC)
    ? now.add(1, 'day').startOf('day').add(12, 'hour').valueOf()
    : noonTodayUTC.valueOf();

  const times = filter(
    order =>
      includes(order.product_id, selectedProductIds) && !isFutures(order.contract_type),
    orders
  ).map(order => {
    const selectedProduct = products?.[order.product_id];
    return selectedProduct?.settlement_time
      ? new Date(selectedProduct.settlement_time).getTime()
      : new Date().getTime();
  });

  const sortedUniqueTimestamps = sort(
    (a, b) => a - b,
    uniq([currentTimestamp, ...times])
  );

  const minTimestamp = sortedUniqueTimestamps[0];
  const maxTimestamp = sortedUniqueTimestamps[sortedUniqueTimestamps.length - 1];

  const dailyTimestamps: number[] = [];
  let currentDay = dayjs(minTimestamp).utc().startOf('day').add(12, 'hour');

  while (currentDay.valueOf() <= maxTimestamp) {
    dailyTimestamps.push(currentDay.valueOf());
    currentDay = currentDay.add(1, 'day').startOf('day').add(12, 'hour');
  }

  dailyTimestamps[0] = currentTimestamp;

  return dailyTimestamps;
};

export { analyzeGetDailyTargetTimestamps };
